<!-- eslint-disable quotes -->
<template>
    <add-to-calendar-button v-if="calendar">
        {{ calendar }}
    </add-to-calendar-button>
</template>

<script>
import 'add-to-calendar-button';

export default {
    name: 'Countdown',
    data() {
        return {
            options: [
                'Apple',
                'Google',
                'iCal',
                'Outlook.com',
                'Yahoo',
            ],
        };
    },
    props: {
        beginDate: { type: String, required: true },
        endDate: { type: String, required: true },
        labelButton: { type: String, required: true },
        title: { type: String, required: true },
    },
    computed: {
        calendar() {
            return {
                name: this.title,
                options: this.options,
                startDate: this.beginDate,
                endDate: this.endDate,
                label: this.labelButton,
                hideIconList: true,
                customCss: '/css/app.css',
                buttonStyle: 'custom',
                hideCheckmark: true,
                customLabels: {
                    apple: 'In your Apple calendar',
                    google: 'In your Google calendar',
                    ical: 'Get the ical file',
                    outlookcom: 'In your Outlook calendar',
                    yahoo: 'In your Yahoo calendar',
                },
            };
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
